import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FolderSelectorComponent } from './folder-selector/folder-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ListComponent } from './list/list.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';
import { CreateComponent } from './create/create.component';
import { AddToProductComponent } from './add-to-product/add-to-product.component';

@NgModule({
  declarations: [FolderSelectorComponent, ListComponent, CreateComponent, AddToProductComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTreeModule,
    MatMenuModule
  ],
  exports: [FolderSelectorComponent, ListComponent]
})
export class FolderModule {}
